var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single_box item"},[_c('img',{attrs:{"src":_vm.item.speciality_icon_url}}),_c('h3',[_vm._v(_vm._s(_vm.item.speciality_name))]),_c('a',{on:{"click":_vm.book}},[_vm._v("Book Now")])])
}
var staticRenderFns = []

export { render, staticRenderFns }